import * as React from 'react';
import type { SVGProps } from 'react';
const SvgAssetsFull = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={32}
    height={32}
    fill="none"
    viewBox="0 0 30 30"
    {...props}
  >
    <path
      fill="var(--color-surface-interactive-secondary-hover)"
      d="M0 8a8 8 0 0 1 8-8h14a8 8 0 0 1 8 8v14a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"
    />
    <path
      fill="var(--color-content-base-secondary)"
      fillRule="evenodd"
      d="M15 6.075c-1.505 0-2.725 1.199-2.725 2.677 0 .875.427 1.652 1.087 2.14.618.458 1.223 1.075 1.223 1.844 0 .225.186.408.415.408.23 0 .415-.183.415-.408 0-.769.605-1.387 1.223-1.844a2.66 2.66 0 0 0 1.086-2.14c0-1.478-1.22-2.677-2.725-2.677Zm-2.725 10.276c0-1.479 1.22-2.678 2.724-2.678s2.725 1.199 2.725 2.678-1.22 2.677-2.725 2.677c-1.504 0-2.724-1.198-2.724-2.677m6.54 1.71c.654.51 1.557.51 2.386.51 1.504 0 2.724 1.198 2.724 2.676 0 1.48-1.22 2.678-2.724 2.678s-2.724-1.199-2.724-2.678q.002-.4.113-.766c.194-.64.168-1.424-.36-1.834a.403.403 0 0 1-.066-.573.42.42 0 0 1 .583-.067zm-7.63 0c-.654.51-1.557.51-2.386.51-1.504 0-2.724 1.198-2.724 2.676 0 1.48 1.22 2.678 2.724 2.678s2.724-1.199 2.724-2.678q-.002-.4-.113-.766c-.194-.64-.168-1.424.359-1.834.18-.14.21-.397.067-.573a.42.42 0 0 0-.583-.067z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgAssetsFull;
